import { render, staticRenderFns } from "./ProviderUpdateForm.vue?vue&type=template&id=8d8fa2a2"
import script from "./ProviderUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProviderUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports